import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { scrollToOffer } from "../data/constants";
interface BuyButtonProps {
  label?: string;
  className?: string;
  fullWidth?: boolean;
}
export function BuyButton({
  label = "Aprende a gestionar tu ciudadanía",
  className = "",
  fullWidth = true
}: BuyButtonProps) {
  return <motion.button type="button" onClick={scrollToOffer} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${fullWidth ? "w-full" : ""} inline-flex items-center justify-center gap-2 rounded-full bg-italian-green px-6 py-4 text-center text-base font-bold text-cream shadow-lg shadow-italian-green/25 transition-colors hover:bg-deep-green ${className}`} data-id="element-46" data-mp="3l1cvex84cofm">
      <span data-id="element-47" data-mp="8jpmexdqxf9h">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-48" data-mp="8l0xzjdfnrb5" />
    </motion.button>;
}